import { memo } from "react";
import { ThemedSearchIcon } from "assets/CXFIcons/Designer/ContextActions";
import ContextHeaderButton from "../ContextHeaderButton";

const SearchButton = ({ editorRef }) => {
  const handleSearch = () => {
    if (editorRef.current) {
      const editor = editorRef.current;
      editor.getAction("actions.find").run();
    }
  };

  return <ContextHeaderButton icon={<ThemedSearchIcon />} label="Search" action={handleSearch} />;
};

export default memo(SearchButton);
